import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { HttpHelperService } from 'src/app/core/services/http-helper.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
import { TransactionSupDocsService } from 'src/app/pages/transaction/services/transaction-sup-docs.service' 
@Injectable({
  providedIn: 'root'
})
export class TransactionRequestService extends BaseProvider {
	mode: any = 'list';
	itemToEdit: any;
	tryEdit: boolean = false;
	requestList: any = [];
  	constructor(
		public globals: GlobalsService,
 		public httpHelper: HttpHelperService,
 		public http: HttpClient,	
 		public ls: LsHelperService,
 		public authService: AuthService,
		public transactionService: TransactionService,
		public transactionSupDocsService: TransactionSupDocsService,
  	) { 
		super();

		this.baseUrl = "userProcessRequest";		
	}	

	getRequests(){
		if(this.transactionService.itemToEdit.Id){
			return new Promise( (resolve, reject) => {
				this.url = this.globals.dataUrl + this.baseUrl + 
						   '/request/' + this.transactionService.itemToEdit.Id;
	
				this.http.get(
					this.url
				)
				.subscribe(
					(data: any) => {
						this.pageData(data.Data);
						this.requestList = data.Data;
						this.transactionSupDocsService.getDocs()
						resolve(data);
					},
					err => {reject(err)}
				);
			});		
		}
	}		

	update(data){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + "/update/" + data.Id;

		    this.http
		    .put(
		      this.url, 
		      data
		    )
		    .subscribe(
		        (resp: any) => {
		        	this.updateItem(data);

		        	resolve(resp);
		        },
		        err => {reject(err)}
		    );
		});			
	}		

	tryUpdate(data){
		this
	}
	createRequest(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl;


		    this.http
		    .post(
		      this.url, {
		      	...params,
		      	...{UserProcessId: this.transactionService.itemToEdit.Id}
			  }
		    )
		    .subscribe(
		        (data: any) => {
		        	resolve(data);
		        },
		        err => {reject(err)}
		    );
		});			
	}		
	canAddRequests: any;
	canEdit(){
		//User has 'can manage documents' policy
		//Transaction is not finished

		let hasPolicy = false;

		hasPolicy = this.authService.hasPolicyBool("CanAddRequests");
		this.canAddRequests = hasPolicy;
		return hasPolicy;
	}
	canViewRequests: any;
	canView(){
		//User has 'can view documents' policy

		let hasPolicy = false;

		hasPolicy = this.authService.hasPolicyBool("CanViewRequests");		
		this.canViewRequests = hasPolicy;
		return hasPolicy;		
	}

	delete(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + 
					   "/delete/" + params.Id

		    this.http
		    .delete(
		      this.url
		    )
		    .subscribe(
		        (data: any) => {
		        	resolve(data);
		        },
		        err => {reject(err)}
		    );
		});				
	}

	createDoc(params){
		return new Promise( (resolve, reject) => {
					
			this.url = this.globals.dataUrl + this.baseUrl + '/createDoc/' + this.transactionService.itemToEdit.Id;

			console.log(params);

		    this.http
		    .post(
		      this.url, 
		      params
		    )
		    .subscribe(
		        (data: any) => {
					resolve(data);
				
		        },
		        err => {reject(err)}
		    );
		});			
		
	}	
	getDocs(){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + 
					   '/process/' + this.transactionService.itemToEdit.Id +
					   '/page/' + this.page +
					   '/size/' + this.size;

			this.http.get(
				this.url
			)
		    .subscribe(
		        (data: any) => {
		        	if(this.page==1){
		        		this.list = data.Data;
		        	}else{
	        			this.pushItems(data.Data);
		        	}

					resolve(data);
					
		        },
		        err => {reject(err)}
		    );
		});		
	}			
}

